import React from "react";
import { Grid } from "@material-ui/core";

import Card from "./Card";
import Chip from "../basics/Chip";

import {
  CardDescription,
  DescriptionCardContent,
  DescriptionCardIcon,
  DescriptionCardTitle,
  Main,
} from "./styles/DescriptionCard";

const DescriptionCard = ({ title, icon, children, onClick }) => {
  return (
    <Main onClick={onClick}>
      <Card line="left" lineColor="primary" padding="7">
        <CardDescription>
          <Grid container spacing={2}>
            <Grid item lg={2}>
              <DescriptionCardIcon>{icon}</DescriptionCardIcon>
            </Grid>
            <Grid item lg={10}>
              {title && (
                <DescriptionCardTitle>
                  <Chip label={title} bgcolor="primary" textcolor="white" />
                </DescriptionCardTitle>
              )}
              <DescriptionCardContent>{children}</DescriptionCardContent>
            </Grid>
          </Grid>
        </CardDescription>
      </Card>
    </Main>
  );
};

export default DescriptionCard;
